module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_leaving_camera-4fc8031491ad88ab833925d97f490206.svg";